import { useQuery } from 'react-query'
import { isNotEmpty } from '../../../_metronic/helpers'

import { ComponentRequest } from '../componentLayout'
import { useContext, createContext, useState } from 'react'
import { FullPageLoader } from '../helper';

export const HomeContext = createContext();

/**
 * EditModalFormWrapper component for fetching and providing data for modal forms.
 * - Uses react-query to fetch data based on itemId from context and getApi prop.
 * - Provides loading state, data, and refetch/setEnableQuery methods via HomeContext.
 * - Renders children with loading overlay when fetching.
 */
export const EditModalFormWrapper = (props) => {
  const { comRequest } = useContext(ComponentRequest);
  const [enabledQuery, setEnableQuery] = useState(true)
  const { itemIdForUpdate } = comRequest
  const enabled = isNotEmpty(itemIdForUpdate) && enabledQuery
  const {
    //isLoading,
    isFetching,
    data,
    // error,
    refetch
  } = useQuery(
    `${comRequest.label}-user-${itemIdForUpdate}`,
    () => props.getApi(itemIdForUpdate),
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabled,
      onError: (err) => {
        console.error(err)
      },
    }
  )

  return (
    <HomeContext.Provider value={{
      isUserLoading: isFetching, data: data, setEnableQuery, refetch, itemIdForUpdate
    }}>
      {isFetching && <FullPageLoader />}
      {props.children}
    </HomeContext.Provider>
  )
}

/**
 * useApiData hook for accessing modal form data and state from HomeContext.
 * - Returns loading state, fetched data, refetch/setEnableQuery methods, and itemId.
 */
export const useApiData = () => {

  // object destructuring
  return useContext(HomeContext)

}




//export { EditModalFormWrapper, useApiData }
